import styled from 'styled-components';

const BtnWrapper = styled.div`
  .outline {
    border: solid 2px #1ec252;
    background-color: transparent;
    color: #1ec252;
  }
  .btn-style {
    cursor: pointer;
    border-radius: 5px;
    background-color: #1ec252;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 5px 15px;
    line-height: 1.2;
    border: solid 1px #1ec252;
    font-family: "Roboto", sans-serif;
    transition: 0.3s;
    &:active,
    &:focus {
      box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
      outline: none;
    }
    &.outline {
      background-color: #ffffff;
      color: #1ec252;
      &:active,
      &:focus,
      &:hover {
        background-color: #1ec252;
        color: #ffffff;
      }
    }
    &:disabled {
      cursor: default;
      opacity: 0.6;
    }
  }
`;

type Props = {
  title?: string,
  outline?: boolean,
  onClickButton?: () => void;
  className?: string;
} & typeof defaultProps;

const defaultProps = {
  outline: false,
  title: '',
  onClickButton() { },
  className: '',
};

const ButtonLite = function ButtonLite(props: Props) {
  const { outline, title, onClickButton } = props;

  return (
    <BtnWrapper {...props} onClick={onClickButton}>
      <span className={`btn-style ${outline ? 'outline' : ''}`}>
        {title}
      </span>
    </BtnWrapper>
  );
};
ButtonLite.defaultProps = defaultProps;
export default ButtonLite;
